import { useContext, useEffect, useState } from "react";
import { DataContext } from "../DataContext";
import { Avatar, Button, ButtonGroup, Chip, CircularProgress, Container, Divider, Grid, List, ListItemAvatar, ListItemButton, ListItemIcon, ListItemText, Paper, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Tooltip, Typography } from "@mui/material";
import WidgetTitle from "../widgets/WidgetTitle";
import { variables } from "../../styles/abstract/variables";
import { AppContext } from "../../AppContext";
import { AccessTimeFilled, Add, Check, Close, CloudUpload, Download, GppBad, GppGood, GppMaybe, OpenInFull, OpenInNew, Preview, QuestionAnswer, QuestionMark, UploadFile } from "@mui/icons-material";
import { Link } from "react-router-dom";
import SelectInput from "../ui/SelectInput";
import $data from "../../services/$data";

import olives from '../../images/olives-picked.webp';
import almonds from '../../images/almonds.webp';
import moment from "moment";
import CreateApplication from "./CreateApplication";
import EmissionReport from "./EmissionReport";

const generateYears = (list) => {
  let years = [];
  list.map(p => {
    p.years.map(y => {
      years.push(y.toString())
    })
  })


  return [...new Set(years)].sort((a, b) => b - a);
}

function CarbonManagementSystem(props) {
  const { user, selected, onUpdateState } = useContext(AppContext);
  const { projectData, projects, onUpdateProjectData, onGetParcels } = useContext(DataContext);
  const [loading, setLoading] = useState({
    parcels: !Boolean(projectData[props.project]?.parcels),
    photos: !Boolean(projectData[props.project]?.photos),
  });
  const [emissionReport, setEmissionReport] = useState(false);
  const [create, setCreate] = useState(false);
  const [reports, setReports] = useState([]);
  const [year, setYear] = useState(moment().format('YYYY'));
  const [reportType, setReportType] = useState('emissions');
  const [filter, setFilter] = useState({
    name: '',
    year: 'All',
    applicability: 'All',
    monitoring: 'All',
    verification: 'All',
  })

  let parcels = [];
  let photos = [];
  let project = null;

  try {
    project = projects.results.find((project) => project.id.toString() === props.project);
    parcels = [...projectData[props.project].parcels]
    photos = [...projectData[props.project].photos];
  } catch {

  }

  const getReports = async () => {
    try {
      let data = await $data.getReports();

      let onlyEmissions = data.results.filter(r => r.tag === `emission_report_${year}` && JSON.stringify(r.project) === props.project);
      
      setReports(data.results.filter(r => r.tag === `emission_report_${year}` && JSON.stringify(r.project) === props.project));
    } catch (error) {
      console.error("Error fetching assessments:", error);
    }
  }

  useEffect(() => {
    if (Boolean(selected)) {
      if (Boolean(projectData.hasOwnProperty(selected))) {
        setLoading(current => ({ ...current, parcels: false, photos: false }));
        parcels = [...projectData[selected].parcels];
        photos = [...projectData[selected].photos];
      } else {
        onUpdateState({ selected: props.project })
        getParcels();
        getPhotos();
      }
    } else {
      onUpdateState({ selected: props.project })
      getParcels();
      getPhotos();
    }
  }, [])

  useEffect(() => {
    getReports();
  }, [year])

  const getParcels = async () => {
    try {
      await onGetParcels(props.project);
    } catch (e) {

    } finally {
      setLoading((loadingState) => ({ ...loadingState, parcels: false }));
    }
  }

  const getPhotos = async () => {
    try {
      let photos = await $data.getPhotos(props.project);
      onUpdateProjectData(selected, { ...projectData[selected], photos: [...photos] });
    } catch (e) {
      console.log(e)
    } finally {
      setLoading((loadingState) => ({ ...loadingState, photos: false }));
    }
  }

  const getStatusBadge = (status) => {
    if (status === 'Draft') return <Chip size="small" label={status} />
    if (status === 'Rejected') return <Chip size="small" icon={<Close fontSize="small" />} label={status} color="error" />
    if (status === 'Approved') return <Chip size="small" icon={<Check fontSize="small" />} label={status} color="primary" />
    if (status === 'In Progress') return <Chip size="small" icon={<AccessTimeFilled fontSize="small" />} label={status} color="warning" />
  }

  const renderContent = () => {
    if (selected === null || selected === undefined) {
      return (
        <Grid item xs={12} textAlign={'center'}>
          <Typography color="primary" variant="h6">Please select a farm</Typography>
        </Grid>
      )
    }
    if (loading.parcels || loading.photos) return (
      <Grid item xs={12} textAlign={'center'}>
        <CircularProgress color="secondary" />
      </Grid>
    )
    if (parcels.length === 0) {
      return (
        <Grid item xs={12} textAlign={'center'}>
          <Typography color="secondary" variant="h6">There are no parcels for selected farm</Typography>
        </Grid>
      )
    }
    console.log(parcels)

    let filtered = parcels.filter(p => {
      let check = true;

      if (p.years.indexOf(parseInt(year)) === -1) {
        check = false;
      }

      // if (filter.applicability !== 'All') {
      //   if (p.applicabilityStatus !== filter.applicability) {
      //     check = false;
      //   }
      // }

      // if (filter.monitoring !== 'All') {
      //   if (p.status.find(s => s.year === parseInt(year))?.monitoring !== filter.monitoring) {
      //     check = false;
      //   }
      // }

      // if (filter.verification !== 'All') {
      //   if (p.status.find(s => s.year === parseInt(year))?.verification !== filter.verification) {
      //     check = false;
      //   }
      // }

      return check
    });

    const renderApplicabilityAvatar = (status) => {
      if (status === 'Draft') return <Tooltip placement="right" arrow title="Applicability Status - Draft">
        <Avatar sx={{ background: variables.secondary }}><GppMaybe color="white" /></Avatar>
      </Tooltip>;

      if (status === 'In Progress') return <Tooltip placement="right" arrow title="Applicability Status - In Progress">
        <Avatar sx={{ background: variables.warningColor }}><AccessTimeFilled color="white" /></Avatar>
      </Tooltip>;

      if (status === 'Rejected') return <Tooltip placement="right" arrow title="Applicability Status - Rejected">
        <Avatar sx={{ background: variables.dangerColor }}><GppBad color="white" /></Avatar>
      </Tooltip>;

      if (status === 'Approved') return <Tooltip placement="right" arrow title="Applicability Status - Approved">
        <Avatar sx={{ background: variables.primary }}><GppGood color="secondary" /></Avatar>
      </Tooltip>;
    }

    return (

      <Grid item xs={12}>
        <TableContainer className="co-background" component={Paper} sx={{ padding: '10px', width: 'calc(100% - 20px)' }}>
          <Table sx={{ '& td': { padding: '0px 10px 0px 0px', border: 'none', textAlign: 'left' }, '& th': { borderColor: `${variables.primary}30 !important`, textAlign: 'left', padding: '7px', '&:first-of-type': { paddingLeft: '7px' } }, position: 'relative' }}>
            <TableHead sx={{ position: 'sticky', top: 0 }}>
              <TableRow>
                <TableCell colSpan={7}>
                  <Button onClick={() => setEmissionReport(true)} size="small" variant="contained" startIcon={<CloudUpload />}>Generate Emissions Report ({year})</Button>
                  {reports.length > 0 && reports.map((report, key) => (
                    <Button color="secondary" key={key} component={"a"} href={report.doc} target="_blank" rel="noopener" size="small" variant="contained" startIcon={<Download />} sx={{ marginLeft: '10px' }}><Stack><Typography>Emissions Report ({year})</Typography>
                    <Typography variant="caption">{moment(report.created_at).format('DD MMM, YYYY HH:mm')}</Typography>
                    </Stack></Button>
                  ))}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell rowSpan={2}>Parcel</TableCell>
                <TableCell colSpan={2}>Emissions ({year})</TableCell>
                <TableCell colspan={2}>Soil Organic Carbon ({year})</TableCell>
                <TableCell colspan={2}>Biomass Reduction ({year})</TableCell>
              </TableRow>
              <TableRow>

                {/* <TableCell>Applicability</TableCell> */}
                <TableCell>Reporting</TableCell>
                <TableCell>Verification</TableCell>
                <TableCell>Reporting</TableCell>
                <TableCell>Verification</TableCell>
                <TableCell>Reporting</TableCell>
                <TableCell>Verification</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {
                filtered.map((parcel, key) => {
                  console.log(parcel.status)
                  return (
                    <TableRow key={key}>
                      <TableCell>
                        <List dense>
                          <ListItemButton component={Link} to={`/dashboard/project/${selected}/carbon-management-parcel/${parcel.id}/${year}/`} sx={{ paddingTop: 0, paddingBottom: 0 }}>
                            <ListItemAvatar>
                              {renderApplicabilityAvatar(parcel.applicabilityStatus)}
                            </ListItemAvatar>
                            <ListItemAvatar>
                              {parcel.history.length === 0 && <Avatar component={Paper}> <QuestionMark /> </Avatar>}
                              {parcel.history.length > 0 && <Avatar component={Paper} elevation={5} src={parcel.history[parcel.history.length - 1]?.crop === 'Almonds' ? almonds : olives} />}
                            </ListItemAvatar>
                            <ListItemText primary={parcel.name} primaryTypographyProps={{ color: 'primary', fontWeight: 'bold', sx: { whiteSpace: 'nowrap', textOverflow: 'ellipsis' } }} secondary={`${parcel.area.toFixed(2)}ha`}></ListItemText>
                          </ListItemButton>
                        </List>
                      </TableCell>

                      <TableCell>{getStatusBadge(parcel.status.find(s => s.year === parseInt(year))?.monitoring)}</TableCell>
                      <TableCell>{getStatusBadge(parcel.status.find(s => s.year === parseInt(year))?.verification)}</TableCell>
                      <TableCell>{getStatusBadge(parcel.status.find(s => s.year === parseInt(year))?.monitoring)}</TableCell>
                      <TableCell>{getStatusBadge(parcel.status.find(s => s.year === parseInt(year))?.verification)}</TableCell>
                      <TableCell>{getStatusBadge(parcel.status.find(s => s.year === parseInt(year))?.monitoring)}</TableCell>
                      <TableCell>{getStatusBadge(parcel.status.find(s => s.year === parseInt(year))?.verification)}</TableCell>
                    </TableRow>
                  )
                })
              }
            </TableBody>
          </Table>
        </TableContainer>
      </Grid>

    );
  }

  return (
    <>
      <Container style={{ marginTop: '30px', marginBottom: '30px' }}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Paper elevation={3} className="co-background" sx={{ padding: '15px 10px 15px 10px', textAlign: 'center' }}>
              <Button onClick={() => setCreate(true)} startIcon={<Add />} variant="contained" color="primary">Create new application</Button>
            </Paper>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Paper elevation={3} className="co-background" sx={{ padding: '15px 10px 0 10px' }}>
              <SelectInput name="Select farm" value={project?.id} items={projects.results.map(p => ({ value: p.id, label: p.name }))} onChange={(evt) => onUpdateState({ selected: evt.target.value })} />
            </Paper>
          </Grid>
          {selected && <Grid item xs={12} sm={6}>
            <Paper component={Stack} direction="row" alignItems="flex-start" spacing={1} elevation={3} className="co-background" sx={{ padding: '15px 10px 0 10px' }}>
              <SelectInput name="Select year of application" value={year} items={generateYears(parcels).map(y => ({ value: y, label: y }))} onChange={(evt) => setYear(evt.target.value)} />
            </Paper>
          </Grid>}
          <Grid item xs={12}>
            <Paper elevation={3} className="co-background" sx={{ padding: '10px' }}>
              <WidgetTitle text={`Farm: ${project?.name || ' - '}`} />
            </Paper>
          </Grid>
          <Grid item xs={12}>
            <Divider color="secondary" light sx={{ background: variables.primary, height: '3px', paddingLeft: '0px !important' }} />
          </Grid>
          {/* <Grid item xs={12}>
            <Stack component={Paper} className="co-background" sx={{ padding: '15px 10px 15px 10px' }} spacing={2}>

              <Typography variant="h6" color="primary" sx={{ fontWeight: 'bold' }}>Report Type</Typography>
              <Stack elevation={3} direction={{ xs: 'column', md: 'row' }} spacing={2}>
                <Button sx={{ fontWeight: 'bold' }} variant={reportType === 'emissions' ? 'contained' : 'outlined'} onClick={() => setReportType('emissions')}>Emissions ({year})</Button>
                <Button sx={{ fontWeight: 'bold' }} variant={reportType === 'soc' ? 'contained' : 'outlined'} onClick={() => setReportType('soc')}>Soil Organic Carbon</Button>
                <Button sx={{ fontWeight: 'bold' }} variant={reportType === 'biomass' ? 'contained' : 'outlined'} onClick={() => setReportType('biomass')}>Biomass Management</Button>
              </Stack>
            </Stack>

          </Grid> */}
          {/* <Grid item xs={12}>
            <Stack component={Paper} elevation={3} className="co-background" sx={{ padding: '15px 10px 0px 10px' }} direction={{ xs: 'column', md: 'row' }} spacing={2}>
              <TextField fullWidth variant="outlined" size="small" label="Parcel name" value={filter.name} onChange={(evt) => setFilter(current => ({ ...current, name: evt.target.value }))} />
              <SelectInput name="Applicability Status" items={['All', 'Draft', 'In Progress', 'Rejected', 'Approved'].map(v => ({ value: v, label: v }))} value={filter.applicability} onChange={(evt) => setFilter(current => ({ ...current, applicability: evt.target.value }))} />
              <SelectInput name="Reporting Status" items={['All', 'Draft', 'In Progress', 'Rejected', 'Approved'].map(v => ({ value: v, label: v }))} value={filter.monitoring} onChange={(evt) => setFilter(current => ({ ...current, monitoring: evt.target.value }))} />
              <SelectInput name="Verification Status" items={['All', 'Draft', 'In Progress', 'Rejected', 'Approved'].map(v => ({ value: v, label: v }))} value={filter.verification} onChange={(evt) => setFilter(current => ({ ...current, verification: evt.target.value }))} />

            </Stack>
          </Grid> */}
          {renderContent()}
        </Grid>
        {create && <CreateApplication onRefresh={getParcels} open={create} onClose={() => setCreate(false)} parcels={parcels} />}
        {emissionReport && <EmissionReport year={year} project={project} open={emissionReport} onClose={(bool) => {
          setEmissionReport(false);
          getReports();
        }} parcels={parcels} photos={photos} />}
      </Container>
    </>
  );
}

export default CarbonManagementSystem;